export const createAddToCart = (element) => {
  if (!element || element.length === 0) {
    return null;
  }
  const instance = {
    $element: null,
    $addToCartButton: null,
    $visitCartButton: null,
    productId: null,
    variationId: null,
    defaultText: null,
    init: function (element) {
      this.$element = jQuery(element);
      this.$addToCartButton = this.$element.find(".js-add-to-cart-button");
      this.$visitCartButton = this.$element.find(".js-visit-cart-button");
      this.productId = this.$addToCartButton.data("product-id");
      this.variationId = this.$element.find("input[name='variation_id']").val();
      this.defaultText = this.$addToCartButton.first().text();
    },
    addClickHandler: function (callback) {
      this.$addToCartButton.on("click", (e) => {
        callback(e);
      });
    },
    getProductId: function () {
      // First try to get it from the button's data attribute
      let productId = this.$addToCartButton.data("product-id");

      // If undefined, try to get from button's value attribute (used in variable product template)
      if (productId === undefined) {
        productId = this.$addToCartButton.val();
      }

      // If still undefined, try to get from hidden input
      if (productId === undefined) {
        productId = this.$element.find("input[name='product_id']").val();
      }

      // If still undefined, try to get from the form's data attribute
      if (productId === undefined) {
        productId = this.$element
          .closest("form.cart, form.variations_form")
          .data("product_id");
      }

      return productId;
    },
    getVariationId: function () {
      return this.$element.find("input[name='variation_id']").val();
    },
    loading: function (text) {
      this.$addToCartButton.prop("disabled", true).text(text);
    },
    done: function () {
      this.$addToCartButton.prop("disabled", false).text(this.defaultText);
    },
    hide: function () {
      this.$addToCartButton.hide();
    },
    showVisitCartButton: function () {
      this.$visitCartButton.show();
    },
  };

  instance.init(element);
  return instance;
};
